"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoupleRightImageOrQuoteProperty = exports.coupleRightImageOrQuotePropertyDefinition = void 0;
exports.coupleRightImageOrQuotePropertyDefinition = {
    view: { label: 'Couple right image or quote' },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'oneOfProperties',
            argument: ['couple-right-image', 'quote'],
        },
    ],
    type: 'one-of-container',
    multiple: false,
    name: 'couple-right-image-or-quote',
};
const isCoupleRightImageOrQuoteProperty = (prop) => {
    return prop.name === exports.coupleRightImageOrQuotePropertyDefinition.name;
};
exports.isCoupleRightImageOrQuoteProperty = isCoupleRightImageOrQuoteProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291cGxlLXJpZ2h0LWltYWdlLW9yLXF1b3RlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY291cGxlLXJpZ2h0LWltYWdlLW9yLXF1b3RlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEseUNBQXlDLEdBQUc7SUFDdkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLDZCQUE2QixFQUFFO0lBQzlDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLGlCQUFpQjtZQUN2QixRQUFRLEVBQUUsQ0FBQyxvQkFBb0IsRUFBRSxPQUFPLENBQUM7U0FDMUM7S0FDRjtJQUNELElBQUksRUFBRSxrQkFBa0I7SUFDeEIsUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsNkJBQTZCO0NBQ0osQ0FBQTtBQUkxQixNQUFNLGlDQUFpQyxHQUFHLENBQUMsSUFBa0IsRUFBMkMsRUFBRTtJQUMvRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssaURBQXlDLENBQUMsSUFBSSxDQUFBO0FBQ3JFLENBQUMsQ0FBQTtBQUZZLFFBQUEsaUNBQWlDLHFDQUU3QyJ9